import { Pagination } from '$core/models/pagination';
import { LanguageService } from '$core/services/language.service';
import { ResizeService } from '$core/services/resize.service';
import {
  MainSearchService,
  SearchResults,
} from '$core/shell/main-search/main-search.service';
import {
  animateChild,
  query,
  stagger,
  transition,
  trigger,
  useAnimation,
} from '@angular/animations';
import { Component, Input } from '@angular/core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { fadeInUp } from 'ng-animate';
import { NgScrollbar } from 'ngx-scrollbar';

@Component({
  selector: 'app-search-items',
  templateUrl: './search-items.component.html',
  styleUrls: [
    '../../../../assets/scss/modules/_menu-items.component.scss',
    './search-items.component.scss',
  ],
  animations: [
    trigger('fadeInUpChild', [
      transition('void => *', [
        useAnimation(fadeInUp, {
          params: { timing: 0.2, a: '10px' },
        }),
      ]),
    ]),
    trigger('fadeInUp', [
      transition('void => *', [
        useAnimation(fadeInUp, { params: { timing: 0.2, a: '-10px' } }),
        query('@fadeInUpChild', stagger('40ms', [animateChild()]), {
          optional: true,
        }),
      ]),
    ]),
  ],
})
export class SearchItemsComponent {
  @Input() public data: Pagination<SearchResults>;
  @Input() public ps: NgScrollbar;
  public isLoading;
  public readonly faChevronDown = faChevronDown;

  public activeIndex: string;

  public get isMobile() {
    return this.resizeService.isMobile;
  }

  constructor(
    private languageService: LanguageService,
    private resizeService: ResizeService,
    private mainSearch: MainSearchService
  ) {}

  // Animation do not works when use localize pipe, use this method
  public localizePath(path: string) {
    return this.languageService.translateRoute(path);
  }

  public onClick(i: number, j: number) {
    if (!this.ps) {
      return;
    }
    const scroll = () => {
      setTimeout(() => {
        const element = this.ps.viewport.nativeElement.querySelector(
          '.menu-items-group--active'
        );
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 40);
    };

    const ij = this.createCombiIndex(i);

    if (this.activeIndex === ij) {
      this.activeIndex = null;
      return;
    }

    this.activeIndex = ij;

    scroll();
  }

  public createCombiIndex(i: number) {
    return i.toString();
  }

  public onScroll() {
    if (this.data && this.data.next_page_url) {
      this.nextPage(this.data.next_page_url);
    }
  }

  public async nextPage(url) {
    this.isLoading = true;
    try {
      const tmpitem = await this.mainSearch.nextPage(url).toPromise();
      tmpitem.data = [...this.data.data, ...tmpitem.data];
      Object.assign(this.data, tmpitem);
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }
}
